import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { navRoleFor, resolveFleetLink } from './navRole';
import { useCurrentFleetId } from './useCurrentFleetId';
import {
  LayoutDashboard, Car, Wrench, FileText,
  Settings, Truck, BarChart3, Shield, Bot
} from 'lucide-react';

// Max 5 tabs for mobile — keep it tight
const mobileNavItems = {
  car_owner: [
    { to: '/', icon: LayoutDashboard, label: 'Home' },
    { to: '/vehicle-profiles', icon: Car, label: 'Vehicles' },
    { to: '/ai', icon: Bot, label: 'Assistant' },
    { to: '/billing', icon: FileText, label: 'Billing' },
    { to: '/profile', icon: Settings, label: 'Settings' },
  ],
  mechanic: [
    { to: '/', icon: LayoutDashboard, label: 'Home' },
    { to: '/jobs', icon: Wrench, label: 'Jobs' },
    { to: '/invoices', icon: FileText, label: 'Invoices' },
    { to: '/profile', icon: Settings, label: 'Settings' },
  ],
  fleet_manager: [
    { to: 'fleet:', icon: LayoutDashboard, label: 'Home' },
    { to: 'fleet:/vehicles', icon: Truck, label: 'Fleet' },
    { to: 'fleet:/reports', icon: BarChart3, label: 'Costs' },
    { to: '/billing', icon: FileText, label: 'Billing' },
    { to: '/profile', icon: Settings, label: 'Settings' },
  ],
  admin: [
    { to: '/', icon: LayoutDashboard, label: 'Home' },
    { to: '/vehicle-profiles', icon: Car, label: 'Vehicles' },
    { to: '/jobs', icon: Wrench, label: 'Jobs' },
    { to: '/fleet', icon: Truck, label: 'Fleet' },
    { to: '/admin', icon: Shield, label: 'Admin' },
  ],
};

export default function BottomTabs() {
  const { user } = useAuth();
  const userType = navRoleFor(user?.user_type);
  const fleetId = useCurrentFleetId(userType === 'fleet_manager');
  // Before a fleet exists there is nothing for Vehicles or Cost Reports to
  // open; they would all resolve to /fleet and light up together.
  const items = (mobileNavItems[userType] || mobileNavItems.car_owner)
    .filter(({ to }) => fleetId || !to.startsWith('fleet:/'));

  return (
    <nav
      className="
        lg:hidden fixed bottom-0 left-0 right-0 z-30
        flex items-center justify-around
        h-16 border-t safe-area-bottom
        bg-surface-card border-border-default shadow-sticky
      "
    >
      {items.map(({ to, icon: Icon, label }) => (
        <NavLink
          key={label}
          to={resolveFleetLink(to, fleetId)}
          end={to === '/' || to === 'fleet:'}
          className={({ isActive }) => `
            flex flex-col items-center justify-center
            min-w-touch min-h-touch px-1
            text-small transition-colors
            ${isActive
              ? 'text-accent font-semibold'
              : 'text-ink-muted'}
          `}
        >
          <Icon size={24} strokeWidth={1.5} />
          <span className="mt-0.5">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
